<template>
  <div>
    <!-- 날짜 -->
    <div
      class="absolute top-0 flex items-center gap-4"
      :class="[!isPrint && 'p-6']"
      style="left: 100px"
    >
      <p v-if="isPrint" class="print-input">{{ form.headerDate }}</p>
      <vc-date-picker
        v-else-if="
          !!form.fieldInfo.start_work_at && !!form.fieldInfo.be_completed_at
        "
        class="inline-block"
        :disabled="isDateDisabled"
        :min-date="new Date(form.fieldInfo.start_work_at)"
        :max-date="new Date(form.fieldInfo.be_completed_at)"
        :masks="masks"
        v-model="form.headerDate"
      >
        <template v-slot="{ inputValue, togglePopover }">
          <ml-input
            class="w-full"
            :value="inputValue"
            @click="
              !isDateDisabled && togglePopover({ placement: 'auto-start' })
            "
            :readonly="isDateDisabled"
          />
        </template>
      </vc-date-picker>
    </div>

    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="{ ...board, readonly: isPostId }"
      :is-print="isPrint"
      @selectField="onSelectField"
    />

    <!-- 사업장개요 -->
    <div class="mt-6">
      <vs-row>
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 사업장개요</h5>
        </vs-col>
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">현장주소(소재지)</div>
          <p v-if="isPrint" class="print-input">{{ form.fieldInfo.address }}</p>
          <ml-input
            :readonly="true"
            v-else
            v-model="form.fieldInfo.address"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">착공일</div>
          <p v-if="isPrint" class="print-input">
            {{ form.fieldInfo.start_work_at }}
          </p>
          <date-selector
            v-else
            :readonly="true"
            class="w-full flex-1"
            v-model="form.fieldInfo.start_work_at"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">준공일</div>
          <p v-if="isPrint" class="print-input">
            {{ form.fieldInfo.be_completed_at }}
          </p>
          <date-selector
            v-else
            :readonly="true"
            class="w-full flex-1"
            v-model="form.fieldInfo.be_completed_at"
          />
        </div>
      </div>
    </div>

    <!-- 작업내용(원도급) -->
    <div class="mt-6" v-if="viewForm">
      <vs-row>
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 작업내용(원도급)</h5>
        </vs-col>
      </vs-row>
      <div class="print-container flex items-start mt-4">
        <div class="label-text mr-4 mt-2">금일</div>
        <p v-if="isPrint" class="print-textarea">{{ form.inputA_1 }}</p>
        <ml-textarea
          v-else
          class="flex-1 w-full"
          rows="5"
          v-model="form.inputA_1"
          :readonly="isReadonly"
        />
      </div>
      <div class="print-container flex items-start">
        <div class="label-text mr-4 mt-2">명일</div>
        <p v-if="isPrint" class="print-textarea">{{ form.inputA_2 }}</p>
        <ml-textarea
          v-else
          class="flex-1 w-full"
          rows="5"
          v-model="form.inputA_2"
          :readonly="isReadonly"
        />
      </div>
    </div>

    <!-- 인원투입 현황(원도급) -->
    <table-budget-day
      v-if="viewForm"
      :isPrint="isPrint"
      title="인원투입 현황(원도급)"
      :infoHeader="['구분']"
      :colPlaceholders="[
        '자동입력(전일까지금액 합산)',
        '숫자입력',
        '자동입력(전일누계 + 금일)',
      ]"
      :totalPlaceholders="[
        '자동입력(전일까지금액 합산)',
        '자동입력(전체 합산)',
        '자동입력(전체 합산)',
      ]"
      :readonly="isReadonly"
      v-model="form.budgetDay1"
    />

    <!-- 주요장비 반입현황(원도급) -->
    <table-budget-day
      v-if="viewForm"
      :isPrint="isPrint"
      title="주요장비 반입현황(원도급)"
      :infoHeader="['장비명', '규격']"
      :colPlaceholders="[
        '자동입력(전월금액 합산)',
        '숫자입력',
        '자동입력(해당년도)',
      ]"
      :totalPlaceholders="[
        '자동입력(전월금액 합산)',
        '자동입력(전체 합산)',
        '자동입력(전체 합산)',
      ]"
      :readonly="isReadonly"
      v-model="form.budgetDay2"
    />

    <!-- 주요장비 반입현황(하도급업체) -->
    <div class="mt-6" v-if="viewForm">
      <vs-row>
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 주요장비 반입현황(하도급업체)</h5>
        </vs-col>
      </vs-row>
      <div class="print-container flex items-start mt-4">
        <div class="label-text mr-4 mt-2">금일</div>
        <p v-if="isPrint" class="print-textarea">{{ form.inputA_3 }}</p>
        <ml-textarea
          v-else
          class="flex-1 w-full"
          rows="5"
          v-model="form.inputA_3"
          :readonly="isReadonly"
        />
      </div>
      <div class="print-container flex items-start">
        <div class="label-text mr-4 mt-2">명일</div>
        <p v-if="isPrint" class="print-textarea">{{ form.inputA_4 }}</p>
        <ml-textarea
          v-else
          class="flex-1 w-full"
          rows="5"
          v-model="form.inputA_4"
          :readonly="isReadonly"
        />
      </div>
    </div>

    <!-- 인원투입 현황(하도급업체) -->
    <table-budget-day
      v-if="viewForm"
      :isPrint="isPrint"
      title="인원투입 현황(하도급업체)"
      :infoHeader="['구분', '직종']"
      :colPlaceholders="[
        '자동(전월금액 합산)',
        '숫자입력',
        '자동입력(해당년도)',
      ]"
      :totalPlaceholders="[
        '자동입력(전월금액 합산)',
        '자동입력(전체 합산)',
        '자동입력(전체 합산)',
      ]"
      :readonly="isReadonly"
      v-model="form.budgetDay3"
    />

    <!-- 주요장비 반입현황(하도급업체) -->
    <table-budget-day
      v-if="viewForm"
      :isPrint="isPrint"
      title="주요장비 반입현황(하도급업체)"
      :infoHeader="['장비명', '규격']"
      :colPlaceholders="[
        '자동입력(전월금액 합산)',
        '숫자입력',
        '자동입력(해당년도)',
      ]"
      :totalPlaceholders="[
        '자동입력(전월금액 합산)',
        '자동입력(전체 합산)',
        '자동입력(전체 합산)',
      ]"
      :readonly="isReadonly"
      v-model="form.budgetDay4"
    />

    <!-- 사진대지 -->
    <photo-upload-grid-module
      v-if="viewForm"
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="isReadonly"
      section-title="사진대지"
      placeholder="점검 현장 사진"
    />

    <!-- 파일첨부-->
    <file-upload-module
      v-if="viewForm"
      id="fileList"
      class="w-full mt-6"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="isReadonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableBudgetDay from "@/components/table-budget/TableBudgetDay.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import DateSelector from "@/components/selector/DateSelector";
import moment from "moment";

export default {
  components: {
    FieldSelectModule,
    TableBudgetDay,
    PhotoUploadGridModule,
    FileUploadModule,
    DateSelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    header: Object,
    value: Object,
  },
  computed: {
    myInfo() {
      return this.$store.state.auth.userInfo;
    },
    projectId() {
      return this.$route.params.proj_id;
    },
    postList() {
      return [...JSON.parse(JSON.stringify(this.$store.state.board.list))];
    },
    postId() {
      return this.$route.params.postId;
    },
    isPostId() {
      return !!this.$route.params.postId;
    },
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        if (this.isPostId && !this.check && !!this.form.stdInfo.field_name) {
          this.check = true;
          this.checkLastPost();
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = value.inputA_2;

        const budgetDay1Total = value.budgetDay1.reduce((prev, _bd) => {
          return prev + (Number(_bd.today) || 0);
        }, 0);
        const budgetDay2Total = value.budgetDay2.reduce((prev, _bd) => {
          return prev + (Number(_bd.today) || 0);
        }, 0);
        const budgetDay3Total = value.budgetDay3.reduce((prev, _bd) => {
          return prev + (Number(_bd.today) || 0);
        }, 0);
        const budgetDay4Total = value.budgetDay4.reduce((prev, _bd) => {
          return prev + (Number(_bd.today) || 0);
        }, 0);

        this.$emit("input", {
          ...value,
          budgetDay1Total,
          budgetDay2Total,
          budgetDay3Total,
          budgetDay4Total,
        });
      },
    },
  },
  data() {
    return {
      check: false,
      isReadonly: true,
      isDateDisabled: !!this.$route.params.postId,
      viewForm: false,
      masks: {
        input: "YYYY년 MM월 DD일",
      },
      form: {
        headerDate: "",
        stdInfo: {},
        fieldInfo: {
          address: "",
          start_work_at: "",
          be_completed_at: "",
        },
        budgetDay1: [],
        budgetDay2: [],
        budgetDay3: [],
        budgetDay4: [],
        budgetDay1Total: 0,
        budgetDay2Total: 0,
        budgetDay3Total: 0,
        budgetDay4Total: 0,

        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",
        photoList: [],
        fileList: [],
      },
    };
  },
  mounted() {
    this.$emit(" saveButtonControl", false);
    this.isReadonly = this.isPostId;
    this.viewForm = this.isPostId;
  },
  methods: {
    async checkLastPost() {
      const projectId = this.projectId;
      const boardId = 261;
      const page = 1;
      const perPage = 10000;

      const keyword = [`content$body.stdInfo.field_name*${this.form.stdInfo.field_name}`];

      await this.$store.dispatch("board/LOAD_POST_LIST", {
        projectId,
        boardId,
        page,
        perPage,
        keyword,
      });

      if (0 < this.postList.length) {
        // 현재 ID가 마지막 포스트인지 체크 (수정 가능하도록)
        if (this.isPostId) {
          const lastId = this.postList[this.postList.length - 1].id;
          if (this.postId === lastId) {
            this.$emit(" saveButtonControl", true);
            this.isReadonly = false;
          }
        }
      }
    },
    onSelectField(data) {
      this.form.fieldInfo.address = data.address;
      this.form.fieldInfo.start_work_at = data.start_work_at;
      this.form.fieldInfo.be_completed_at = data.be_completed_at;

      this.resetForm();
      if (!!data.start_work_at && !!data.be_completed_at) this.loadListBoard();
    },
    resetForm() {
      this.$emit(" saveButtonControl", false);
      this.viewForm = false;

      this.$set(this.form, "headerDate", "");

      this.$set(this.form, "budgetDay1", []);
      this.$set(this.form, "budgetDay2", []);
      this.$set(this.form, "budgetDay3", []);
      this.$set(this.form, "budgetDay4", []);

      this.$set(this.form, "inputA_1", "");
      this.$set(this.form, "inputA_2", "");
      this.$set(this.form, "inputA_3", "");
      this.$set(this.form, "inputA_4", "");

      this.$set(this.form, "photoList", []);
      this.$set(this.form, "fileList", []);
    },

    // 내용불러오기
    async loadListBoard() {
      const projectId = this.projectId;
      const boardId = 261;
      const page = 1;
      const perPage = 10000;
      const keyword = [`content$body.stdInfo.field_name*${this.form.stdInfo.field_name}`];

      await this.$store.dispatch("board/LOAD_POST_LIST", {
        projectId,
        boardId,
        page,
        perPage,
        keyword,
      });

      this.oldDataSetting();
    },

    oldDataSetting() {
      if (0 < this.postList.length) {
        // 이전 데이터가 있으면 날짜선택을 비활성화한다.
        this.isDateDisabled = true;

        const _budgetData1 = [];
        const _budgetData2 = [];
        const _budgetData3 = [];
        const _budgetData4 = [];

        /**
         * 날짜계산 : 준공일이 넘지 않도록
         */
        const prevDate = this.getContent(
          this.postList[this.postList.length - 1]
        ).headerDate;
        const postDate = moment(prevDate).startOf("day").add(1, "days");
        const lastDate = moment(this.form.fieldInfo.be_completed_at).startOf(
          "day"
        );
        const _dur = moment.duration(postDate.diff(lastDate)).asDays();

        // 날짜가 준공일을 넘었을때 에러 alert
        if (0 < _dur) {
          const customAlert = new CustomEvent("customAlert", {
            detail: {
              title: "에러",
              message: "선택한 현장의 모든 날짜에 예산을 작성하였습니다.",
            },
          });
          window.dispatchEvent(customAlert);
          return;
        }

        for (const post of this.postList) {
          const content = this.getContent(post);

          this.setDate(postDate.format("YYYY-MM-DD"));
          this.viewForm = true;
          this.$emit(" saveButtonControl", true);

          content.budgetDay1.map((_day) => {
            const _dataIndex = _budgetData1.findIndex((e) => e.id === _day.id);
            if (_dataIndex === -1) _budgetData1.push({
              ..._day,
              yesterday: _day.total,
              today: null,
              readonly: true,
            });
            else {
              _budgetData1[_dataIndex].yesterday =
                Number(_budgetData1[_dataIndex].yesterday) + Number(_day.today);
              _budgetData1[_dataIndex].total =
                _budgetData1[_dataIndex].yesterday;
            }
          });
          content.budgetDay2.map((_day) => {
            const _dataIndex = _budgetData2.findIndex((e) => e.id === _day.id);
            if (_dataIndex === -1) _budgetData2.push({
              ..._day,
              yesterday: _day.total,
              today: null,
              readonly: true,
            });
            else {
              _budgetData2[_dataIndex].yesterday =
                Number(_budgetData2[_dataIndex].yesterday) + Number(_day.today);
              _budgetData2[_dataIndex].total =
                _budgetData2[_dataIndex].yesterday;
            }
          });
          content.budgetDay3.map((_day) => {
            const _dataIndex = _budgetData3.findIndex((e) => e.id === _day.id);
            if (_dataIndex === -1) _budgetData3.push({
              ..._day,
              yesterday: _day.total,
              today: null,
              readonly: true,
            });
            else {
              _budgetData3[_dataIndex].yesterday =
                Number(_budgetData3[_dataIndex].yesterday) + Number(_day.today);
              _budgetData3[_dataIndex].total =
                _budgetData3[_dataIndex].yesterday;
            }
          });
          content.budgetDay4.map((_day) => {
            const _dataIndex = _budgetData4.findIndex((e) => e.id === _day.id);
            if (_dataIndex === -1) _budgetData4.push({
              ..._day,
              yesterday: _day.total,
              today: null,
              readonly: true,
            });
            else {
              _budgetData4[_dataIndex].yesterday =
                Number(_budgetData4[_dataIndex].yesterday) + Number(_day.today);
              _budgetData4[_dataIndex].total =
                _budgetData4[_dataIndex].yesterday;
            }
          });
        }
        this.form.budgetDay1 = _budgetData1;
        this.form.budgetDay2 = _budgetData2;
        this.form.budgetDay3 = _budgetData3;
        this.form.budgetDay4 = _budgetData4;
      } else {
        // 이전 데이터가 없으면 착공 시작일로 설정한다.
        this.setDate(this.form.fieldInfo.start_work_at);
        this.viewForm = true;
        this.$emit(" saveButtonControl", true);
      }
    },
    getContent(data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content);
        return content.body;
      }
    },
    getHeader(data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content);
        return content.header;
      }
    },
    setDate(data) {
      this.form.headerDate = moment(data).format("YYYY-MM-DD");
    },
  },
};
</script>

<style scoped>
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  padding-right: 12px;
}
</style>
